import React, { forwardRef, useImperativeHandle } from 'react';
import { Col, Row } from 'antd';
import { Wrapper } from './TopBar.style'
// import { useHistory } from 'react-router-dom';
import userpic from '@iso/assets/images/logop7_nfund.png';
import Cliente from '../components/Cliente';

const TopBar = forwardRef((props, ref) => {
    // let history = useHistory();

    useImperativeHandle(ref, () => ({
        // setQTDTot(val) {
        //     setqtdTotal(val)
        // },
    }));

    const goBack = () => {
        // history.push('/dashboard')
    }

    return (
        <Wrapper style={{display: 'flex', background: (props.cor) ? props.cor : '#FFF', boxShadow:'rgba(0, 0, 0, 0.24) 0px 3px 8px'}}>
            <Row style={{height: '100%', width: '100%'}} gutter={24} className='topKPIs'>
                <Col span={1} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', padding: '0', backgroundColor: 'transparent'}}>
                    <div className='center'>
                        <img alt="user" src={userpic} style={{width: '100%', height: '100%', cursor: 'pointer'}} />
                        {/* onClick={goBack} title='Voltar' */}
                    </div>
                </Col>
                <Col span={11}>&nbsp;</Col>
                <Col span={12}>
                    <Cliente currentOrder={props.currentOrder}/>
                </Col>
            </Row>
        </Wrapper>
    );
});

export default TopBar